<template>
    <div>
        <p class="categories-title">
            CATEGORIES
        </p>
        <div v-for="category in filteredCategories" :key="category.uuid">
            <hr v-if="category.uuid === automationCategoryCustom.uuid">
            <div class="media sidebar-category-item"
                 @click="onCategoryClick(category)">
                <AutomationCategoryIcon :uuid="category.uuid" class="mr-2" style="width: 18px"/>
                <div class="media-body">
                    {{ category.name }}
                </div>
            </div>
        </div>
        <div v-if="isEditMode" class="mt-3">
            <button @click="onAddCategory" class="btn btn-outline-primary btn-sm btn-block">
                Add Category
            </button>
        </div>
    </div>
</template>

<script>
import AutomationCategoryIcon from '../categories/AutomationCategoryIcon'
import {SETTINGS_AUTOMATION_CATEGORIES} from '../../settings/settings-tabs'
import {AutomationTypes} from '@/types/automations/types'
import {automationCategoryCustom} from '@/types/automations/categories'

export default {
    name: 'AutomationCategoriesNav',
    components: {AutomationCategoryIcon},
    inject: ['getAvailableCategories'],
    props: {
        type: {
            type: String,
            required: true,
            default: AutomationTypes.AUTOMATION
        },
        isEditMode: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            automationCategoryCustom
        }
    },
    computed: {
        isMarketplace() {
            return this.type === AutomationTypes.MARKETPLACE
        },

        categories() {
            return this.getAvailableCategories({type: this.type, withCustom: !this.isMarketplace})
        },

        filteredCategories() {
            if (this.isEditMode) {
                return this.categories.filter(c => c.uuid !== automationCategoryCustom.uuid)
            }
            return this.categories
        }
    },
    methods: {
        onCategoryClick(category) {
            this.$emit('select', category.uuid)
        },

        onAddCategory() {
            this.$router.push({
                name: 'settings',
                params: {
                    page: SETTINGS_AUTOMATION_CATEGORIES
                },
                query: {
                    type: this.type
                }
            })
        }
    }
}
</script>

<style scoped lang="scss">
.categories-title {
    font-size: 12px;
    font-weight: 700;
    color: $color-grey-primary;
}

.sidebar-category-item {
    padding: 8px 16px;
    font-size: 16px;

    &:hover {
        cursor: pointer;
        border-radius: 3px;
        background-color: rgba(133, 19, 155, 0.05);
    }
}
</style>
